module.exports = __webpack_public_path__ + "561072b9b0aceacab04616b5d736eeb8.png";